
import React, { useEffect } from "react";
import { BiCloudUpload } from "react-icons/bi";

const UploadFile = ({
    label,
    name,
    accept,
    register,
    errors,
    setValue,
    startsWith,
    placeholder,
    preview,
    setPreview,
    setDuration,
}) => {
    const readAndDisplayImage = (file) => {
        if (file && file.type.startsWith(startsWith)) {
            const reader = new FileReader();
            reader.onload = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    const handleLoadedMetadata = (event) => {
        const videoDuration = event.target.duration;
        setDuration(Math.floor(videoDuration));
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        readAndDisplayImage(file);
    };
    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        readAndDisplayImage(file);
    };
    const clearPreview = () => {
        setPreview(null);
        setDuration(null);
    };
    useEffect(() => {
        if (preview) {
            setValue(name, preview);
        } else {
            setValue(name, '');
        }
    }, [name, preview, setValue]);

    return (
        <div>
            <div className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>{label} <sup className='text-pink-200'>*</sup></div>
            <div
                className='w-full h-full p-[12px] border border-richblack-300 border-dashed bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
            >
                {preview ? (
                    <div>
                        {startsWith === 'image/' ? (
                            <img
                                src={preview}
                                alt="Preview"
                                className="w-full h-full object-cover rounded-md"
                                loading="lazy"
                            />
                        ) : startsWith === "video/" ? (
                            <video
                                src={preview}
                                onLoadedMetadata={handleLoadedMetadata}
                                controls
                                preload="auto"
                                playsInline
                                tabIndex={'-1'}
                                className="rounded-md w-full h-full aspect-video"
                            />
                        ) :
                            startsWith === 'application/pdf' ? (
                                <iframe
                                    title="pdf"
                                    src={preview}
                                    type="application/pdf"
                                    className="rounded-md w-full h-[20rem]"
                                />
                            ) : startsWith === 'text/plain' ? (
                                <iframe
                                    title="plain-text"
                                    src={preview}
                                    type="text/plain"
                                    className="rounded-md w-full h-[20rem]"
                                />
                            ) :
                                <p>Unsupported file type.</p>
                        }

                        <button onClick={clearPreview} className="my-3 underline text-richblack-300 text-center w-full">Clear</button>
                    </div>
                ) : (
                    <div className="w-full">
                        <label htmlFor={name}>
                            <div
                                className="h-[20rem] flex justify-center items-center cursor-pointer"
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}
                            >
                                <div className="flex flex-col gap-10 items-center justify-center w-full">
                                    <span className="bg-yellow-900 w-fit p-3 rounded-full text-3xl text-yellow-50">
                                        <BiCloudUpload />
                                    </span>
                                    <span className="text-richblack-300">
                                        <p>Drage and drop an {placeholder},</p>
                                        <p>or click to <span className="text-yellow-50">Browse</span> from file</p>
                                    </span>
                                    <ul className="list-disc flex justify-between w-[60%] text-sm text-richblack-300">
                                        <li>Aspect ratio 16.9</li>
                                        <li>Recommended size 1024x576</li>
                                    </ul>
                                </div>
                            </div>
                        </label>
                        <input
                            type="file"
                            name={name}
                            id={name}
                            accept={accept}
                            className="hidden"
                            {...register(name, { required: true, onChange: handleFileSelect })}
                        />
                    </div>
                )}
            </div>
            {errors[name] && <span className='text-pink-200 text-sm'>{label} is required</span>}
        </div>
    );
};

export default UploadFile;